"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  badge: 'знак',
  close: 'Закрыть',
  dataIterator: {
    noResultsText: 'Сәйкес жазбалар табылған жоқ',
    loadingText: 'Деректерді жүктеу...'
  },
  dataTable: {
    itemsPerPageText: 'Әр беттегі жолдар саны:',
    ariaLabel: {
      sortDescending: 'Кему реті бойынша бірыңғайланған',
      sortAscending: 'Өсу реті бойынша бірыңғайланған',
      sortNone: 'Бірыңғайланбаған',
      activateNone: 'Сұрыптауды алып тастау үшін белсендіріңіз',
      activateDescending: 'Кему реті бойынша бірыңғайландыру үшін белсендіріңіз',
      activateAscending: 'Өсу реті бойынша бірыңғайландыру үшін белсендіріңіз'
    },
    sortBy: 'Келесі рет бойынша сұрыптау'
  },
  dataFooter: {
    itemsPerPageText: 'Әр беттегі жазба саны:',
    itemsPerPageAll: 'Все',
    nextPage: 'Келесі бет',
    prevPage: 'Алдыңғы бет',
    firstPage: 'Бірінші бет',
    lastPage: 'Соңғы бет',
    pageText: '{2} жазбадан {0}-{1} жазба'
  },
  datePicker: {
    itemsSelected: '{0} выбран',
    nextMonthAriaLabel: 'Келесі ай',
    nextYearAriaLabel: 'Келесі жыл',
    prevMonthAriaLabel: 'Өткен ай',
    prevYearAriaLabel: 'Өткен жыл'
  },
  noDataText: 'Деректер жоқ',
  carousel: {
    prev: 'Алдыңғы слайд',
    next: 'Келесі слайд',
    ariaLabel: {
      delimiter: 'Слайд {0} / {1}'
    }
  },
  calendar: {
    moreEvents: 'Еще {0}'
  },
  fileInput: {
    counter: 'Файлов: {0}',
    counterSize: 'Файлов: {0} (всего {1})'
  },
  timePicker: {
    am: 'AM',
    pm: 'PM'
  },
  pagination: {
    ariaLabel: {
      wrapper: 'Беттер бойынша навигация',
      next: 'Келесі бет',
      previous: 'Алдыңғы бет',
      page: 'Бетке өту {0}',
      currentPage: 'Ағымдағы бет {0}'
    }
  },
  rating: {
    ariaLabel: {
      icon: 'Rating {0} of {1}'
    }
  }
};
exports.default = _default;
//# sourceMappingURL=ru.js.map